exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".metrics-action-buttons .link {\n  padding: 0 12px;\n}\n.metric-filter-options label {\n  font-weight: 600;\n  margin: 6px;\n  padding: 6px 12px;\n  border: 1px solid var(--color-divider);\n}\n.metric-fail-on-icon {\n  color: var(--color-warning);\n}\n.metric-fail-on-icon.critical {\n  color: var(--color-danger);\n}\n", ""]);

